/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($, Tc) {
	'use strict';

	/**
	 * GhqPressReleaseSearch
	 *
	 * @author Michael Keller
	 * @namespace Tc.Module
	 * @class GhqPressReleaseSearch
	 * @extends Tc.Module
	 */
	Tc.Module.GhqPressReleaseSearch = Tc.Module.extend({

		on: function(callback) {
			var mod = this,
				$ctx = mod.$ctx;

			$ctx.find('.standardSubmitBtn').on('click', '', function() {
				mod.startSearch();
			});

			$ctx.on('keyup', '.keyword', function(e) {
				if (e.keyCode === 13) {
					mod.startSearch();
				}
			});

			callback();
		},

		startSearch: function() {
			var mod = this,
				$ctx = mod.$ctx;
			mod.fire('search', {fulltext: $ctx.find('.keyword').val()});
		}
	});
}(window.Tc.$, window.Tc));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.GhqPressReleaseSearch.js
// module id = 144
// module chunks = 0